import React, { memo, useMemo } from "react";
import { Link } from "react-router-dom";
import ItemsList from "../../../components/ItemsList/ItemsList";
import { dateTimeFormat, formatDescription } from "../../Board/Board";
import moment from "moment/moment";
import {
  formatHoursDuration,
  getDuration,
} from "../../WorkingIntervals/WorkingIntervals";
export default memo(function WorkIntervals({ items = [] }) {
  const tableHeaders = useMemo(() => {
    return [
      {
        field: "started_at",
        headerName: "Date",
        sortable: true,
        type: "string",
        maxWidth: 150,
        flex: 1,
        valueGetter: (params) =>
          params.value
            ? `${moment(params.value).format(dateTimeFormat)} - ${(params.row.ended_at ? moment(params.row.ended_at) : moment()).format(dateTimeFormat)}`
            : "",
      },
      {
        field: "name",
        headerName: "Number",
        sortable: true,
        flex: 1,
        type: "string",
        renderCell: (item) => (
          <>
            {item.row?.task?.name && (
              <Link to={item.row?.task?.permalink_url} target="_blank">
                <span
                  dangerouslySetInnerHTML={{
                    __html: formatDescription(item.row.task.name),
                  }}
                />
              </Link>
            )}
          </>
        ),
      },
      {
        field: "duration",
        headerName: "Duration",
        sortable: true,
        type: "string",
        maxWidth: 150,
        flex: 1,
        renderCell: (params) =>
          formatHoursDuration(params.value ?? getDuration(params.row)),
      },
      {
        field: "status",
        headerName: "Status now",
        sortable: false,
        type: "string",
        maxWidth: 100,
        flex: 1,
        renderCell: (item) => item.row.task?.status,
      },
    ];
  }, []);

  return (
    <ItemsList
      items={items}
      headers={tableHeaders}
      server={false}
      gridId="work-intervals"
      totalCount={items.length}
      defaultPageSize={20}
    />
  );
});
